import _ from 'underscore';
import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn(LocaleService, $filter, $scope, StateUtils, LoadSaveService, $window, submissionViewModel, EventHub, CPPRequestCallbackService, AppConfig) {
    var ctrl = Object.create(BaseCtrl);
    var flowModel = StateUtils.activeDataForState(true).flowModel;
    var submissionVM = submissionViewModel();
    $scope.AppConfig = AppConfig;

    ctrl.init = function () {

        var quoting = submissionVM.quoteData.value;
        $scope.page = {
            submission: submissionVM
        };

        $scope.callBackStep = "InitialMessage";
        $scope.showDetails = false;
        $scope.page.offeredQuotes = quoting.offeredQuotes;

        $scope.page.offeringLabels = ctrl._setOfferingLabels($scope.page.offeredQuotes);
        $scope.page.baseOffering = ctrl._setBaseOffering($scope.page.offeredQuotes);
        $scope.showQuoteStartDateInHeader = !!ApplicationFeatures.getAllFeatures().showQuoteStartDateInHeader;
        $scope.quote = quoting.offeredQuotes[0];
        $scope.accountHolder = submissionVM.baseData.accountHolder;
        $scope.glCoverage = submissionVM.lobData.commercialPackage.generalLiability.coverables.coverages.value[0];
        submissionVM.lobData.commercialPackage.commercialProperty.coverables.locations.value[0].buildings[0].coverages.forEach(function (element) {
            if (element.publicID == "CPBPPCov") {
                $scope.stockCoverage = element;
                $scope.stockCoverageOption = _.where($scope.stockCoverage.terms[0].options, { code: $scope.stockCoverage.terms[0].chosenTermValue });
            }
            if (element.publicID == "CPEquipCov") {
                $scope.equipCoverage = element;
                $scope.equipCoverageOption = _.where($scope.equipCoverage.terms[0].options, { code: $scope.equipCoverage.terms[0].chosenTermValue });
            }
        });
        $scope.cpCoverages = submissionVM.lobData.commercialPackage.commercialProperty.coverables.locations.value[0].buildings[0].coverages;
        $scope.imCoverage = submissionVM.lobData.commercialPackage.inlandMarine.coverables.coverages.value[0];

        $scope.coverageArray = [[$scope.glCoverage.name, "$" + $scope.glCoverage.terms[0].chosenTermValue], [$scope.equipCoverage.name, $scope.equipCoverageOption[0].name], [$filter('translate')('ama.quotedetails.coverages.Business Interruption Coverage'), $filter('translate')('ama.quotedetails.coverages.Business Interruption Coverage.value')]];
        if ($scope.stockCoverage.selected) {
            $scope.coverageArray.push([$scope.stockCoverage.name, $scope.stockCoverageOption[0].name]);
        }
        if ($scope.imCoverage.selected) {
            $scope.coverageArray.push([$scope.imCoverage.name, "Included"]);
        }
        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
        $scope.phoneNumber = '';
        $scope.callbakNumber = {
            value: '',
            aspects: {
                validationMessage: $filter('translate')('ama.quotedetails.callback.phone.invalid'),
                validationMessages: [],
                required: true,
                inputCtrlType: 'text',
                get valid() {
                    var valid = /\d{3}-\d{3}-\d{4}|\d{10}/.test($scope.callbakNumber.value);
                    $scope.callbakNumber.aspects.validationMessages = [];
                    if (!valid) {
                        $scope.callbakNumber.aspects.validationMessages.push($filter('translate')('ama.quotedetails.callback.phone.invalid'));
                    }
                    return valid;
                }

            }
        };
    };

    ctrl.printQuote = function () {
        EventHub.publish('wizard', 'print');
        $window.print();
    };

    ctrl.setSelectedQuote = function (quote) {
        if (quote.branchCode === 'CUSTOM' || quote.branchCode.indexOf('Version') === 0) {
            $scope.$broadcast('CustomQuoteSelected', [quote.publicID]);
        }
    };

    ctrl.getCustomQuoteHeaderCostString = function () {
        return LocaleService.getLocaleInfo().currency.symbol + '?';
    };

    ctrl.buy = function (selectedQuote, numberOfPayments) {
        // stash some bind information in state data so it can be accessed later when we call the bind method
        StateUtils.activeDataForState(true).numberOfPayments = numberOfPayments;
        StateUtils.activeDataForState(true).chosenQuote = selectedQuote.publicID;
        flowModel.next(submissionVM);
    };

    ctrl.error = function (data) {
        flowModel.jumpToExit('error', data);
    };

    ctrl.requestCallback = function () {
        var phoneNumber = document.getElementById('phoneNumber').value;
        //        phoneNumber = phoneNumber.replace("(", "").replace(")", "").replace("-", "").replace(" ", "");

        if (!$scope.callbakNumber.aspects.valid) {
            return;
        }
        CPPRequestCallbackService.requestCallback(submissionVM.value.quoteID, $scope.callbakNumber.value).then(function (result) {
            if (result) {
                $scope.callBackStep = 'CompletedMessage';
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    ctrl._setOfferingLabels = function (standardOfferings) {
        return _.map(standardOfferings, function (offering) {
            if (typeof offering.branchCode !== 'undefined') {
                return $filter('translate')('quoteandbind.controllers.QuoteDetails.' + offering.branchCode);
            }
        });
    };

    ctrl._setBaseOffering = function (standardOfferings) {
        if (angular.isArray(standardOfferings) && standardOfferings.length === 1) {
            return standardOfferings[0];
        } else if (angular.isArray(standardOfferings) && standardOfferings.length > 1) {
            return standardOfferings[1];
        }
    };

    return ctrl.create($scope);
};
fn.$inject = ['LocaleService', '$filter', '$scope', 'StateUtils', 'qnb.LoadSaveService', '$window', 'submissionViewModel', 'EventHub', 'ama.CPPRequestCallbackService', 'ama.AppConfig'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/controllers/QuoteDetailsCtrl.js
// module id = 838
// module chunks = 0